import { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { DriverStatus } from '@/features/driver/domain/enums/DriverStatus'
import type { CargoStatus } from '@/features/package/domain/enums/CargoStatus'
import type { PackageStatus } from '@/features/package/domain/enums/PackageStatus'

export class PackageMonitoringRouteEntity {
  monitoringCargoRoutes?: Array<MonitoringCargoRouteEntity> | null
  trackedDriverRoute?: {
    route?: string | null
  }
  currentDriverLocation?: LngLatEntity
  currentDriverStatus?: DriverStatus
}

export class MonitoringCargoRouteEntity {
  packageId?: string
  packageStatus?: PackageStatus
  cargoId?: string | null
  cargoStatus?: CargoStatus
  route?: string | null
  duration?: number
  distance?: number
}
